import { gsap } from 'gsap';

const ShareCount = () => {
  const elm = document.querySelector('.js-share-count');
  const postId = elm.dataset.postId;

  if (postId) {
    fetch(tofinoJS.ajaxUrl, {
      method: 'post',
      body: new URLSearchParams({
        action: 'ajax-share-count',
        security: tofinoJS.nextNonce,
        postId: postId
      })
    })
      .then(async (response) => {
        const data = await response.json();

        if (data > 0) {
          const formatted = { value: data };

          gsap.fromTo(
            formatted,
            {
              value: 0
            },
            {
              value: data,
              duration: 1,
              ease: 'power1',
              onUpdate () {
                elm.innerHTML = new Intl.NumberFormat('en-US', {
                  maximumFractionDigits: 0
                }).format(formatted.value);
              }
            }
          );

          elm.parentElement.classList.remove('hidden');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

export default ShareCount;
